export enum AuthActionTypes {
  FETCH = '@auth/fetch',
  FETCH_STARTED = '@auth/fetch/started',
  FETCH_SUCCEED = '@auth/fetch/succeed',
  FETCH_FAILED = '@auth/fetch/failed',
  LOGOUT = '@auth/logout',
}
